import { connect } from 'react-redux';
import {
  fetchPerson,
  setPersonForm,
  deletePerson,
} from '../../../store/modules/person';

import Person from '../components/Person';

const mapActionCreators = {
  fetchPerson,
  setPersonForm,
  deletePerson,
};

const mapStateToProps = state => ({
  person: state.person.persons[state.person.current],
  persons: state.person.persons,
  companies: state.company.companies,
  fetching: state.person.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Person);



// WEBPACK FOOTER //
// ./src/routes/Person/containers/PersonContainer.js